import { InstantieId } from '@eformulieren/model'

/**
 * De route van de adviseurpagina (R-184, ontwerp 7.4a): `/<instantie>/advies`.
 *
 * Wie een adviesvraag aanneemt, gaat hierheen en niet naar het formulier: een adviseur ziet eerst de
 * vraag en verklaart of hij een belang heeft, en pas daarna wat er is gedeeld (besluit van NWO van
 * 30 oktober 2026). Het pad is een eigen segment achter de instantie, zodat het niet botst met
 * `instantieFromPath` (precies één id) of met een voorvulling in de query (een naam gelijk aan een
 * veld-id). De pod serveert de pagina op elk pad dat een browser opvraagt (`page.ts`), dus ook hier.
 */

const SUFFIX = 'advies'

export function adviserPath(instantieId: string): string {
  return `/${encodeURIComponent(instantieId)}/${SUFFIX}`
}

/** De instantie uit `/<instantie>/advies`, met of zonder sluitende slash; anders niets. */
export function instantieFromAdviserPath(path: string): string | undefined {
  const parts = path.replace(/^\/+|\/+$/g, '').split('/')
  if (parts.length !== 2 || parts[1] !== SUFFIX) return undefined
  const id = parts[0] ?? ''
  return InstantieId.safeParse(id).success ? id : undefined
}
